import {ref} from "vue";
import {defineStore} from "pinia";
import {ICar} from "@/interfaces/ICar";

export const useCarStore = defineStore('cars', () => {
    const cars = ref<ICar[]>([]);

    // Обновление техник
    const updateCars = (carsList: any []) => {
        const preventCars: ICar[] = [];
        carsList.forEach((car: any) => {
            preventCars.push({
                id: car.car_id,
                brandName: car.brand_name,
                signNumber: car.sign_number,
                garageNumber: car.garage_number
            })
        });
        cars.value = preventCars;
    };

    return {
        cars,
        updateCars,
    };
});